export default __webpack_public_path__ + "ce8bfb528dfabaff34e193defd7506b3.svg";